import React, { useRef, useEffect, useMemo, useState } from 'react';
import { Form, Input, InputNumber, Row, Col, Divider, Tooltip, DatePicker } from 'antd';
import BlockWrapper from '@/components/edit-activity-plan/block-wrapper';
import { prefixCls } from '@/constants';
import { toMoment, toTimeStamp } from '@/components/edit-activity-plan/transform-time';
// import { textareaLayout } from '@/components/edit-activity-plan/contants'
import validator from '@/common/validator';
import utils from '@/common/utils';
import { DownOutlined, UpOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import ErrorMsgFromBackend from '@/components/error-msg-from-backend';
// import RangePicker from '@/form-component/range-picker';
import OpenedScope from '@/components/edit-activity-plan/opened-scope';
import SelectCategory from '@/components/edit-activity-plan/select-category';
import SelectActivityLevel from '@/components/edit-activity-plan/form-activity-select-activity-level';
import SelectHBHLevel from '@/components/edit-activity-plan/form-activity-select-h_b_h-level';
import Department from './department';
import { acitivtyRangePickerShouldUpdate, createTimeFn } from './activity-range-picker';
import moment from 'moment';
// import ActIntroduceEditor from './activity-introduce-editor'
import ActIntroduceEditor from '@/components/wangeditor-for-acore';
import SimpleNote from '@/components/simple-note';
import './index.less';

const { RangePicker } = DatePicker;
const _initialData = {
  openStatus: 0,
  salePool: 0,
  activityPlanRooms: [], // 活动会场list以json格式传输
};

/**
 * form 整个流程 初始化 -> 验证 -> 提交 -> 发起请求 -> 响应请求
 */
function FormActivity(props) {
  const {
    initialData = _initialData,
    onFinish = () => {},
    ActivityName = () => null,
    ActivityType = () => null,
    // IfuseCommodityPool = () => null,
    FormFooter,
  } = props;
  const data = useMemo(() => {
    const cache = { ..._initialData, ...toMoment(initialData) };

    cache.marketPrice = utils.fen2yuan(cache.marketPrice);
    cache.dailySales = utils.fen2yuan(cache.dailySales);

    (cache.activityPlanRooms || []).forEach((item) => {
      if (typeof item.orderAmount === 'number') {
        item.orderAmount = utils.fen2yuan(item.orderAmount);
      }
    });

    return cache;
  }, [initialData]);

  const formInstance = useRef(null);
  useEffect(() => {
    formInstance.current.setFieldsValue({ ...data }); // 设置表单初始值，可即时更新
  }, [data]);

  function _onFinish(values) {
    values = Object.assign({}, values);
    values = toTimeStamp(values);

    // 将活动等级格式化成数字，用于后端排序
    if (typeof values.level === 'string' && values.level) {
      values.level = +values.level;
    }

    values.marketPrice = utils.yuan2fen(values.marketPrice);
    values.dailySales = utils.yuan2fen(values.dailySales);

    (values.activityPlanRooms || []).forEach((item) => {
      if (typeof item.orderAmount === 'number') {
        item.orderAmount = utils.yuan2fen(item.orderAmount);
      }
    });

    // 重置后端下发的错误
    errMsgFromBackEnd && setErrMsgFromBackEnd(null);

    onFinish(values, setErrMsgFromBackEnd);
  }

  const [errMsgFromBackEnd, setErrMsgFromBackEnd] = useState(null);

  function disabledDate(current) {
    // Can not select days before today
    return current && current < moment().endOf('day').subtract(1, 'day');
  }

  // 控制完善基本信息的展开与否的参数，展开 true； 收起 false
  // 新建活动时默认隐藏“完善活动基本信息”的各字段，展开后展示；
  // 编辑活动时默认展示“完善活动基本信息”的各字段；
  const [isformfullInfoStretch, setIsformfullInfoStretch] = useState(() => {
    return initialData.activityName;
  });
  return (
    <Form
      scrollToFirstError
      validateTrigger="onBlur"
      ref={formInstance}
      labelAlign="left"
      name="basic"
      onFinish={_onFinish}
      layout="vertical"
      className="activity-form-detail-edit"
    >
      <BlockWrapper title="活动基本信息">
        <Divider className="add-basic-info-divider" />
        <SimpleNote className="activity-form-detail-edit-info">
          请认真填写*星标内容，这些内容将在“运营人员关联子活动时”和“商家进行主题活动活动报名时”展示。
        </SimpleNote>
        <Row>
          <Col span={7}>
            <ActivityName />
          </Col>
          <Col offset={1} span={7}>
            <Department />
          </Col>
          <Col offset={1} span={7}>
            <Form.Item
              name="activityTime"
              label="活动时间"
              validateTrigger="onChange"
              rules={[{ type: 'array', required: true, message: '活动时间不能为空' }]}
            >
              <RangePicker
                disabledDate={disabledDate}
                className={`${prefixCls}-picker-full-size`}
                placeholder={['开始日期', '结束日期']}
                showTime
              />
            </Form.Item>
          </Col>
          <Col span={7}>
            <ActivityType />
          </Col>
          <Col offset={1} span={7}>
            <SelectActivityLevel />
          </Col>
          <Col offset={1} span={7}>
            <SelectCategory required />
          </Col>
          <Col span={7}>
            <Form.Item
              rules={[
                {
                  max: 50,
                  message: '利益点不能超过50个字符',
                },
              ]}
              name="interestPoint"
              label="利益点"
            >
              <Input placeholder="请输入50字以内的利益点" />
            </Form.Item>
          </Col>
          <Col span={23}>
            <Form.Item
              label={
                <>
                  <span>活动介绍</span>
                  <span className="form-actIntro-description">
                    建议填写活动的背景、目标、核心利益点、核心策略等内容。
                  </span>
                </>
              }
              name="remark"
              required
              validateTrigger="onChange"
              rules={[
                {
                  validator: (_, val) => {
                    return new Promise((resolve, reject) => {
                      if (!val) return reject(new Error('请填写活动介绍'));
                      const a = document.createElement('div');
                      a.innerHTML = val;
                      const b = a.innerText || a.textContent;
                      if (b.length > 500) return reject(new Error('活动介绍最多500个字符'));
                      return resolve();
                    });
                  },
                },
              ]}
            >
              <ActIntroduceEditor placeholder="请添加具体的活动描述，可填写活动的背景、目标、核心利益点、核心策略等内容。介绍内容请控制在500字以内。" />
            </Form.Item>
          </Col>
        </Row>
      </BlockWrapper>
      <BlockWrapper
        title={
          <div>
            完善基本信息
            {!isformfullInfoStretch ? (
              <DownOutlined className="form-fullInfo-icon" onClick={() => setIsformfullInfoStretch(true)} />
            ) : (
              <UpOutlined className="form-fullInfo-icon" onClick={() => setIsformfullInfoStretch(false)} />
            )}
            <span className="form-fullInfo-description">完善信息后可支撑查看数据看板里的相关效果数据</span>
          </div>
        }
      >
        <Divider className="add-basic-info-divider" />
        <div
          style={
            isformfullInfoStretch ? { position: 'relative' } : { position: 'absolute', top: '-9999px', left: '-9999px' }
          }
        >
          <Row>
            <Col span={7}>
              <Form.Item shouldUpdate={acitivtyRangePickerShouldUpdate}>
                {createTimeFn({
                  name: 'preTime',
                  label: (
                    <div>
                      预热期
                      <Tooltip title="填写正确的预热期时间段，后续可在数据看板查看预热期的活动效果数据">
                        <ExclamationCircleOutlined />
                      </Tooltip>
                    </div>
                  ),
                })}
              </Form.Item>
            </Col>
            <Col offset={1} span={7}>
              <Form.Item shouldUpdate={acitivtyRangePickerShouldUpdate}>
                {createTimeFn({
                  name: 'specialTime',
                  label: (
                    <div>
                      专场期
                      <Tooltip title="填写正确的专场期时间段，后续可在数据看板查看专场期的活动效果数据">
                        <ExclamationCircleOutlined />
                      </Tooltip>
                    </div>
                  ),
                })}
              </Form.Item>
            </Col>
            <Col offset={1} span={7}>
              <Form.Item shouldUpdate={acitivtyRangePickerShouldUpdate}>
                {createTimeFn({
                  name: 'highTime',
                  label: (
                    <div>
                      高潮期
                      <Tooltip title="填写正确的高潮期时间段，后续可在数据看板查看高潮期的活动效果数据">
                        <ExclamationCircleOutlined />
                      </Tooltip>
                    </div>
                  ),
                })}
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item shouldUpdate={acitivtyRangePickerShouldUpdate}>
                {createTimeFn({
                  name: 'backTime',
                  label: (
                    <div>
                      返场期
                      <Tooltip title="填写正确的返场期时间段，后续可在数据看板查看返场期的活动效果数据">
                        <ExclamationCircleOutlined />
                      </Tooltip>
                    </div>
                  ),
                })}
              </Form.Item>
            </Col>
            <Col offset={1} span={7}>
              <Form.Item className="form-item-suffix-end-wrap" label={<div>市场费用</div>}>
                <Form.Item
                  validateFirst
                  name="marketPrice"
                  rules={[
                    {
                      validator: validator.getValidateNumberMaxThanZero('市场费用需大于0'),
                    },
                    {
                      validator: validator.validateInt,
                    },
                    {
                      validator: validator.getValidateNumberMax('市场费用不可大于max', 100000000),
                    },
                  ]}
                  noStyle
                >
                  <InputNumber
                    formatter={(value) => utils.thousands(value, value)}
                    className="form-el-full-size"
                    placeholder="请填写数字"
                  />
                </Form.Item>
                <span className="form-item-suffix-end">元</span>
              </Form.Item>
            </Col>
            <Col offset={1} span={7}>
              <Form.Item
                className="form-item-suffix-end-wrap"
                label={
                  <div>
                    预估日销售额
                    <Tooltip title="填写预估日销售额后，后续可在数据看板查看日销售额的实际达成情况">
                      <ExclamationCircleOutlined />
                    </Tooltip>
                  </div>
                }
              >
                <Form.Item
                  validateFirst
                  name="dailySales"
                  noStyle
                  rules={[
                    {
                      validator: validator.getValidateNumberMaxThanZero('预估日销售额需大于0'),
                    },
                    {
                      validator: validator.validateInt,
                    },
                    {
                      validator: validator.getValidateNumberMax('预估日销售额不可大于max', 10000000000),
                    },
                  ]}
                >
                  <InputNumber
                    formatter={(value) => utils.thousands(value, value)}
                    className="form-el-full-size"
                    placeholder="请输入数字"
                  />
                </Form.Item>
                <span className="form-item-suffix-end">元</span>
              </Form.Item>
            </Col>
            <Col offset={1} span={7}>
              <SelectHBHLevel />
            </Col>
          </Row>
        </div>
      </BlockWrapper>
      <OpenedScope />
      <ErrorMsgFromBackend msg={errMsgFromBackEnd} />
      <FormFooter />
    </Form>
  );
}

export default FormActivity;
